<div class="learnspace-theme white-box">
  <div class="content-wrapper">
    <div *ngIf="wondaLogoPath" class="logo">
      <img [src]="wondaLogoPath">
    </div>
    <div class="title">Create your new hub</div>
    <form [formGroup]="hubForm">
      <mat-form-field>
        <input matInput placeholder="Name your Hub" formControlName="title">
      </mat-form-field>
      <mat-form-field>
        <div class="url-title-input">
          <span>spaces.wondavr.com/</span>
          <input matInput formControlName="urlTitle">
        </div>
        <mat-error *ngIf="hubForm.get('urlTitle').hasError('specialchars')">
          Your hub title cannot contain whitespace or special char (except - and _)
        </mat-error>
        <mat-error *ngIf="hubForm.get('urlTitle').hasError('reserved')">
          Unfortunately, this title is a reserved keyword and thus cannot be used
        </mat-error>
        <mat-error *ngIf="hubForm.get('urlTitle').hasError('checkUnicity')">
          this url is already taken
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Hub type</mat-label>
        <mat-select formControlName="hub_type">
          <mat-option value="enterprise">
            Enterprise
          </mat-option>
          <mat-option value="university">
            University
          </mat-option>
          <mat-option value="agency">
            Agency
          </mat-option>
          <mat-option value="personal">
            Personal
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="add-logo-button">
        <div class="light-text">Upload your hub logo</div>
        <file-dropper (assetUploaded)="addLogoId($event)"></file-dropper>
        <span>Max 1024px, transparent png format</span>
      </div>
      <div class="async-button-container">
        <button mat-raised-button [class.hidden]="creationInProgress" color="primary" (click)="createHub()"
          [disabled]="hubForm.invalid">CREATE
          HUB
        </button>
        <div class="stacked-child" *ngIf="creationInProgress">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      </div>
    </form>
  </div>
</div>